<div class="bento-layout" [class.loading]="loading()">
  <div>

    @for(rib of ribbonList; track $index){
    <button class="ribbon" [class.selected]="rib.type === ribbon.type" (click)="handleClick.emit(rib.type)">
      <img [src]="rib.images.scene" alt="">
      <div class="bg" [style.background]="rib.color"></div>
    </button>
    }

  </div>
  <div>

    <div class="text-wrapper animated n1">
      <div class="title">
        {{'modal.ribbon.colors.titles.'+currentRibbon().type|translate}}
      </div>
      <div class="description animated n2">
        {{'modal.ribbon.colors.descriptions.'+currentRibbon().type|translate}}
      </div>
    </div>

    <div>
      <div class="image-wrapper animated n3">
        <img [src]="currentRibbon().images.box" alt="">
      </div>

      <div class="image-wrapper animated n4" [style.background]="currentRibbon().color">
        <img [src]="currentRibbon().images.ribbon" alt="">
      </div>
    </div>
  </div>

  <div>

    <div class="image-wrapper animated n5">
      <img [src]=" currentRibbon().images.scene" alt="">
    </div>

  </div>
</div>
